// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React, { useState } from 'react';

import { MrErrorModal } from '@ion/components';
import { Button, Stack, Typography } from '@metarouter-private/mr-mui';
import { useInsertPipelineIntegration } from '@ion/api';
import CenteredLoader from 'app/components/CenteredLoader';
import PipelineIntegrationForm from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/PipelineIntegrationForm';
import { CONSENT_FORM_TYPES } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/CONSENT_FORM_TYPES';
import { NoIntegrations } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/NoIntegrations';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import { usePipelineIntegrationModalContext } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/context/pipeline-integration-modal-context';
import { useGetAvailableIntegrations } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/hooks/useGetAvailableIntegrations';

export const AddIntegration = () => {
  const [errorMsg, setErrorMsg] = useState(null);
  const { pipeline } = usePipelinePageContext();
  const { onCloseModal } = usePipelineIntegrationModalContext();
  const { isLoading, hasAvailableIntegrations, integrationsData, availableIntegrations } =
    useGetAvailableIntegrations(pipeline);
  const [createPipelineIntegration] = useInsertPipelineIntegration({
    onCompleted: () => {
      onCloseModal();
    },
    onError: err => {
      setErrorMsg(err.errorMsg);
    },
  });

  const onSubmit = data => {
    const integration = integrationsData.find(integrationData => integrationData.id === data.integration);
    createPipelineIntegration({
      pipeline,
      integration,
      playbookId: data.revision,
      pipelineVars: data.pipelineVars,
      readyForDeploy: true,
      consentCategoryId: data.consentCategory,
      consentMode: data.consentMode,
    });
  };

  if (isLoading) {
    return (
      <>
        <div className="header">
          <Typography variant="h5" component="h2">
            Add New Integration
          </Typography>
        </div>
        <div className="content">
          <Stack spacing={2} alignItems="center">
            <Stack role="status" alignItems="center">
              <CenteredLoader />
              <Typography>Loading integrations...</Typography>
            </Stack>
            <Button variant="text" onClick={onCloseModal}>
              Cancel
            </Button>
          </Stack>
        </div>
      </>
    );
  }

  return (
    <>
      {hasAvailableIntegrations ? (
        <PipelineIntegrationForm
          pipeline={pipeline}
          availableIntegrations={availableIntegrations}
          onSubmit={onSubmit}
          type={CONSENT_FORM_TYPES.add}
          onCancel={onCloseModal}
        />
      ) : (
        <NoIntegrations onCancel={onCloseModal} />
      )}

      {errorMsg && (
        <MrErrorModal
          header={'Error Adding Integration to Pipeline'}
          errorMessage={errorMsg}
          closeModal={() => setErrorMsg(false)}
        />
      )}
    </>
  );
};
